import { Http } from "@/util";

export function listVehicle(param) {
  return Http.post("/admin/vehicle/list", param);
}

export function listVehicleInsurance(param) {
  return Http.post("/admin/vehicle/insurance/query", param);
}

export function addVehicleInsurance(param) {
  return Http.post("/admin/vehicle/insurance/save_update", param);
}

export function getVehicleInfo(id) {
  return Http.post("/admin/vehicle/info", { id });
}

export function saveOrUpdateVehicleInfo(param) {
  return Http.post("/admin/vehicle/save_or_update", param);
}

export function reportVehicleData(vehicleId) {
  return Http.get("/admin/vehicle/report_data", { vehicleId });
}

/**
 * 获取车辆电池检测报告（按 vehicleId，仅查 MongoDB）
 * @param {number} vehicleId 车辆ID
 * @param {string} [reportDateTime] 报告时间 yyyy-MM-dd HH:mm:ss，不传则查最近一次
 */
export function getBatteryReport(vehicleId, reportDateTime) {
  const params = { vehicleId };
  if (reportDateTime) params.reportDateTime = reportDateTime;
  return Http.get("/admin/vehicle/battery_report", params);
}

export function bindEtc(vehicleId) {
  return Http.get(`/admin/vehicle/etc/bind`, { vehicleId });
}

/**
 * 获取登录二维码
 */
export function getG12123QrCode(accountId) {
  return Http.get("/admin/vehicle/g12123/getQrCode", { accountId });
}

/**
 * 执行任务
 * @param {string} accountId 账户ID
 * @param {object} options 可选参数 { startDate, endDate } 格式 yyyy-MM-dd
 */
export function doG12123Task(accountId) {
  const params = { accountId };
  return Http.get("/admin/vehicle/g12123/doTask", params);
}

/**
 * 验证登录
 */
export function verifyG12123Login(accountId, token) {
  return Http.get("/admin/vehicle/g12123/verifyLogin", { accountId, token });
}

/**
 * 获取12123登录状态，已登录则无需扫码
 */
export function getG12123IsLogin(accountId) {
  return Http.get("/admin/vehicle/g12123/isLogin", { accountId });
}

/**
 * 电池告警 - 分页列表，支持按车牌号查询
 */
export function listBatteryAlarm(param) {
  return Http.post("/admin/vehicle/battery_alarm/list", param);
}

/**
 * 车辆违章记录 - 分页列表
 */
export function listVehicleViolation(param) {
  return Http.post("/admin/vehicle/violation/list", param);
}

/**
 * 车辆违章记录 - 违章描述选项（当前记录去重）
 */
export function listVehicleViolationWfms() {
  return Http.post("/admin/vehicle/violation/wfms_options", { _hideLoading: true });
}

/**
 * 违章描述开罚单配置
 */
export function getViolationPunishConfig() {
  return Http.post("/admin/vehicle/violation/punish_config/get", { _hideLoading: true });
}

export function saveViolationPunishConfig(param) {
  return Http.post("/admin/vehicle/violation/punish_config/save", param);
}

/**
 * 为尚未开单的违章补开罚单
 */
export function openViolationPunishBill(id) {
  return Http.post("/admin/vehicle/violation/open_punish_bill", { id });
}

/**
 * 车辆违章记录 - 详情
 */
export function getVehicleViolationInfo(id) {
  return Http.post("/admin/vehicle/violation/info", { id });
}

/**
 * 车辆违章记录 - 新增或更新
 */
export function saveOrUpdateVehicleViolation(param) {
  return Http.post("/admin/vehicle/violation/save_or_update", param);
}

/**
 * 充电记录 - 分页列表
 */
export function listVehicleCharging(req) {
  return Http.post("/admin/vehicle/charging/list", req || {});
}

/**
 * 行程耗电量统计 - 按车辆分组
 * @param {Object} param { pathId, startTime, endTime, brand }
 */
export function listBatteryConsumptionStats(param) {
  return Http.post("/admin/vehicle/battery_consumption_stats", param || {});
}

/**
 * 行程电量明细 - 司机在当前查询条件下的明细记录
 * @param {Object} param { driverId, pathId, startTime, endTime, brand }
 */
export function listBatteryConsumptionDetails(param) {
  return Http.post("/admin/vehicle/battery_consumption_details", param || {});
}

/**
 * 充电记录 - 某司机在指定时间段内的具体电量信息（弹框图表）
 * @param {Number} driverId 司机ID
 * @param {String} startTime 开始时间 yyyy-MM-dd HH:mm:ss
 * @param {String} endTime 结束时间 yyyy-MM-dd HH:mm:ss
 */
export function getChargingChargeInfos(driverId, startTime, endTime) {
  return Http.get("/admin/vehicle/charging/chargeInfos", {
    driverId,
    startTime,
    endTime
  });
}

/**
 * 损耗件分页查询（按车辆、司机、时间、类型）
 * @param {Object} param { page: { current, size }, param: { vehicleId, vehicleNo, bindDriverName, type, installDateStart, installDateEnd, createTimeStart, createTimeEnd } }
 */
export function listConsumable(param) {
  return Http.post("/admin/consumable/list", param);
}

/**
 * 损耗件更新（编辑已有轮胎等）
 * @param {Object} consumable 损耗件对象，需含 id
 */
export function updateConsumable(consumable) {
  return Http.post("/admin/consumable/update", consumable);
}

/**
 * 轮胎初始化（批量写入损耗件表并创建初始检查记录）
 * @param {Array} tires 轮胎列表，每项需含 vehicleId, position，可选 installInitialMileage,  brand, size 等
 */
export function initTire(tires) {
  return Http.post("/admin/consumable/tire/init", tires);
}

/**
 * 按轮胎ID（损耗件ID）查询该轮胎的所有操作记录
 * @param {Number} tireId 轮胎对应的损耗件 id (t_vehicle_consumable.id)
 */
export function listTireOp(tireId) {
  return Http.get("/admin/consumable/tire/opList", { tireId });
}

/**
 * 轮胎异常备注上报
 * @param {Object} param { vehicleId, position, remark, photos?, partnerBillId? }
 */
export function addTireOpRemark(param) {
  return Http.post("/admin/consumable/tire/add_remark", param);
}

/** 车辆异常记录分页 */
export function pageVehicleAnomalyRecord(param) {
  return Http.post("/admin/vehicle-anomaly-record/list", param);
}

/** 车辆异常记录保存（新增或编辑，需含 vehicleId、driverId） */
export function saveVehicleAnomalyRecord(record) {
  return Http.post("/admin/vehicle-anomaly-record/save", record);
}

/** 车辆异常记录删除 */
export function deleteVehicleAnomalyRecord(id) {
  return Http.post("/admin/vehicle-anomaly-record/delete", { id });
}
